// import axios from "axios";

// const api = axios.create({
//   baseURL: "http://localhost:8000/api/", // adjust to your Django host
//   withCredentials: true, // for session cookie auth
// });

// // Redirect to login on 403/401
// api.interceptors.response.use(
//   (r) => r,
//   (error) => {
//     if (error.response?.status === 401 || error.response?.status === 403) {
//       window.location.href = "/login";
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;


// axios instance with interceptors

// src/api/client.ts
import { refreshToken } from "@/auth/auth";
import { useToastStore } from "@/ui/toastStore";
import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
//   baseURL: "http://127.0.0.1:8000/api",
//   baseURL: "https://pure.tmadvances.com/api",
  withCredentials: true,
});

// In-memory access token
let accessToken: string | null = null;

export const setAccessToken = (token: string | null) => {
  accessToken = token;
};
export const getAccessToken = () => accessToken;

// attach access token
api.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

// auto-refresh on 401 + global error toast
const toast = useToastStore.getState().push;
let lastToast: { msg: string; at: number } | null = null;

function shouldIgnoreGlobalToast(url: string | undefined) {
  if (!url) return false;
  const lower = url.toLowerCase();
  return (
    lower.includes("manifest.json") ||
    lower.includes("/me/") ||
    lower.includes("/auth/refresh")
  );
}

function showToastOnce(msg: string, severity: "error" | "warning" | "info" | "success" = "error") {
  const now = Date.now();
  if (lastToast && lastToast.msg === msg && now - lastToast.at < 3000) return;
  lastToast = { msg, at: now };
  toast(msg, severity);
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;

    if (original?.url?.includes("auth/refresh")) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;

      try {
        await refreshToken();

        // Re-attach token if we have one after refresh
        if (accessToken) {
          original.headers = original.headers ?? {};
          original.headers.Authorization = `Bearer ${accessToken}`;
        }

        return api(original); // retry original request
      } catch (err) {
        return Promise.reject(err);
      }
    }

    // Global error toast (unless suppressed)
    const suppress = (original as any)?.suppressGlobalErrorToast;
    const url = original?.url || "";
    if (!suppress && !shouldIgnoreGlobalToast(url)) {
      if (!error.response) {
        showToastOnce("Can't reach the server. Check your connection.");
      } else {
        const status = error.response.status;
        const detail =
          (error.response.data && (error.response.data.detail || error.response.data.error)) ||
          error.message ||
          "Something went wrong";
        if (status >= 500) {
          showToastOnce(`Server error (${status}). Please try again.`);
        } else if (status === 401 || status === 403) {
          // Skip noisy auth toasts by default; handled elsewhere
        } else {
          showToastOnce(detail);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
